<template>
	<div v-if="user.subscription" :class="{'mt-5': $root.source == 'bennet'}">
		<h3
			v-html="`Metodo di pagamento`"
		/>
		<section>
			<div class="form">
				<p v-if="user.subscription && user.subscription.payment_method">
					<div style="display: flex" v-if="!changeable">
						<div>Attualmente stai utilizzando:
							<span
								v-text="$t('components.payment.method_' + user.subscription.payment_method.replace(/\s+/g, '_'))"
							/>.
							<span class="link-detail" v-on:click="change()">Cambia</span>
						</div>
						<div style="flex-grow: 1"></div>
						<div>
							<img v-if="user.subscription.payment_method == 'paypal'" src="https://api.quomi.it/oldimg/paypal-quomi.webp" >
							<img v-else src="https://api.quomi.it/oldimg/metodi-pagamento-quomi.webp" >
						</div>
					</div>
				</p>
				<p v-if="changeable">
					<span class="link-detail" v-on:click="unchange()">Annulla modifica</span>
				</p>
				<div class="payment-form" :class="{'hide': !changeable}">
					<label class='form-field-row checkout-card tag-partner' for='method_paypal'>
						<div class="checkout-payment-select">
							<input
								type="radio"
								id='method_paypal'
								class='hide'
								:checked="method === 'paypal'"
								@click="selectMethod('paypal')"
							>
							<div
								class="check"
								for='method_paypal'
							/>
							<span>
								{{ $t("components.payment.paypal") }}
								<br>
								<span
									class='payment-free'
									v-html="$t('components.payment.free')"
								/>
							</span>

							<span
								class='checkout-payment-icons'
							>
								<img
									src="https://api.quomi.it/oldimg/paypal-quomi.webp"
									alt='logo paypal'
								>
							</span>
						</div>
					</label>

					<label class='form-field-row checkout-card' for='method_credit-card'>
						<div class="checkout-payment-select">

						<input
							type="radio"
							id='method_credit-card'
							class='hide'
							:checked="method === 'creditCard'"
							@click="selectMethod('creditCard')"
						>
						<div
							class="check"
							for='method_credit-card'
						/>
						<span>{{ $t("components.payment.credit_cart") }}<br>
							<span
								class='payment-free'
								v-html="$t('components.payment.free')"
							/>
						</span>

						<span
							class='checkout-payment-icons'
						>
							<img src="https://api.quomi.it/oldimg/metodi-pagamento-quomi.webp" :alt='$t("components.payment.accepted_cards")'>
						</span>

						</div>

					</label>

					<div v-show="method === 'creditCard'" class="card-form">
						<div id="setup-form">
						  <div id="payment-element"></div>
						</div>

						<div
							v-if="stripe.error"
							class='error'
							v-html="stripe.error.message"
						/>
					</div>
				</div>

				<flash
					:flash="flash"
					:state="state"
				/>


				<CTA
					v-if="method"
					isWithLoader
					:content="`Aggiorna`"
					isArrow
					@click="updatePayment()"
					:loading="updating"
				/>
			</div>
		</section>

	</div>
</template>

<script>
import { UserApi } from '../../api/UserApi'
import { OrderApi } from '../../api/OrderApi'
import { Card, createToken } from 'vue-stripe-elements-plus'
import Flash from '../Parts/Flash'
import { prices } from '../../mixins/prices'
import { EdenredApi } from '../../api/EdenredApi'
import { stepPaymentStore } from '../../store/stepPaymentStore'

import { errorStore } from '../../store/errorStore'
import { stripeHelper } from '../../mixins/stripeHelper'  

export default {
	mixins: [
		prices,
    stripeHelper
	],

	props: {
		ctaLabel: {
			type: String,
			default: 'Aggiorna'
		}
	},

	computed: {
		user () {
			return this.$root.user
		},
		order () {
			return this.user.order
		},

        edenredState () {
        	return {
        		confirmed: this.orderHasEdenred,
        		estimated: this.edenredTicketEstimated,
        		authorized: this.edenredTicketEstimated || this.orderHasEdenred
        	}
        }
	},
	data () {
		return {
      redirectTo: 'checkout',
			errorStore: errorStore.state,
			changeable: false,
			method: null,

			wallet: null,
			refer: {
				src: null,
				total: 0
			},

			loading: {
				wallet: false,
				refer: false,
				edenred: false
			},

			flash: null,
			state: null,

			updating: false
		}
	},

	components: {
		Card,
		Flash
	},

	methods: {
		change() {
			//this.method = null
			this.changeable = true
		},
		unchange() {
			this.selectMethod(null)
			this.changeable = false
		},
		logout () {
			this.loading['edenred'] = true
			var token = this.user.order.token
			var em = new EdenredApi()			
			return em.logout(token)

			.then(response => {
				var user = this.user
				user.subscription.partners.edenred = false
                if (user) user.order = response.body.data.resource
    
				this.$root.updateUser(user)

				this.loading['edenred'] = false
			})
		},

		selectMethod (method) {
			this.method = method
			this.$emit("changed", method)
		},

		onUpdateStripeCard ($event) {
			this.stripe.error = $event.error
			this.stripe.complete = $event.complete
		},



		updatePayment () {
			this.flash = null
			this.updating = true

			if (!this.user.subscription) return

			var om = new OrderApi()

			if (this.method === 'creditCard') {
				return stepPaymentStore.makeAgreementStripe().then(response => {
					this.flash = "Modifiche applicate.";
					this.state = 'success'
					this.updating = false
					this.unchange();
				}).catch(response => {
					this.flash = errorStore.format(response)
					this.state = 'error'
					this.updating = false
				})
			}
			if (this.method === 'paypal') {
				om.askPaypal({
					redirect_url_success: location.protocol+'//'+location.host + '/checkout/verify?status=success',
					redirect_url_cancel: location.protocol+'//'+location.host + '/checkout/verify?status=cancel',
					subscription_token: this.user.subscription.token
				}).then(response => {
					window.location.href = response.body.data.redirect
				}).catch(response => {

				})

				// Redirect page flow
			}
		}
	},

	mounted () {
		if (!this.user) return
		if (!this.user.subscription) return

		this.flash = this.$route.params.error ? this.$route.params.error : null
		this.state = this.$route.params.state ? this.$route.params.state : null

		//this.method = this.user.subscription.payment_method === 'paypal' ? 'paypal' : 'creditCard'


    this.initializeStripe();
	}
}

</script>

<style scoped>
.price {
	font-size: 30px;
}

.form {
}

.checkout-card{
	border-radius: 4px;
	cursor: pointer;
	-webkit-transition: border-color .3s;
	transition: border-color .3s;
	display: flex;
	margin: 20px auto;
}

.card-form {
	margin: 20px auto;
}
.checkout-card:hover {
	background-color: #EDEDED;
}
.checkout-payment-icons{
	display:flex;
	align-items: center;
	margin-left: auto;
}
.checkout-payment-icons img{
	max-height: 30px;
	width: auto;
	mix-blend-mode: multiply;
}
.checkout-payment-select{
  font-size: 13px;
	width:100%;
	display: flex;
	padding: 5px;
	align-items: center;
	flex-wrap: nowrap;
}

.checkout-payment-select input[type='radio']{
	height: 16px;
	width: 16px;
	margin-right: 5px;
}

.cc-label {
	padding: 0 0 10px 0;
}

.cc-label > div {
	padding: 0 10px;
}
.payment-free{
	color:var(--quomi-primary);
	font-style: normal;
	font-size: 12px;
}

.checkout-payment-select .radio {
	position: relative;
	display: inline-block;
	height: 50px;
	width: 50px;
	z-index: 2;
}
.checkout-payment-select .check {
	position: relative;
	display: inline-block;
	min-height: 30px;
	min-width: 30px;
	margin-right: 10px;
}

.cc-stripe {
	border: 2px solid #ededed;
	padding: 15px;
	border-radius: 4px;
}
.col-3 .check {
	cursor: pointer;
	height: 37px;
}
.checkout-payment-select .radio::after,
.checkout-payment-select .radio::before,
.checkout-payment-select .check::after,
.checkout-payment-select .check::before {
	position: absolute;
	top: 0;
	left: 0;
	content: '';
	height: 100%;
	width: 100%;
	/* Force hardware acceleration */
	-webkit-transform: translateZ(0);
			transform: translateZ(0);
	-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
}
.checkout-payment-select .radio::before {
	/* green circle */
	border: 3px solid #ffffff;
	background: #EDEDED;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .check::before {
	/* green square */
	border: 1.5px solid var(--quomi-primary);
	background: #ffffff;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .radio::after,
.checkout-payment-select .check::after {
	background: url('../../assets/img/content/icon-check.svg') no-repeat center center;
}
.checkout-payment-select .radio::before {
	border-radius: 50%;
}
.checkout-payment-select .check::before {
	border-radius: 4px;
}
.checkout-payment-select .selected .radio::before {
	background: var(--quomi-primary);
	border-color: #ffffff;
}
.checkout-payment-select .selected .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

input[type="radio"]:checked + .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

.StripeElement {
	background-color: white;
	padding: 10px 12px;
	border-radius: 4px;
	border: 1px solid transparent;
	box-shadow: 0 1px 3px 0 #e6ebf1;
	-webkit-transition: box-shadow 150ms ease;
	transition: box-shadow 150ms ease;
}

.StripeElement--focus {
	box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
	border-color: #fa755a;
}

.StripeElement--webkit-autofill {
	background-color: #fefde5 !important;
}

@media (max-width: 800px) {
	.section-title {
		flex-wrap: wrap;
	}

	.checkout-payment-icons img {
		max-height: 30px;
	}

	.icons {
		margin: 10px 0;
	}

}
</style>
